import React, { useEffect } from 'react'
import { CalendarNav, Datepicker, CalendarPrev, CalendarNext, setOptions } from '@mobiscroll/react'
import './DashboardCalendar.scss'
import { CContainer } from '@coreui/react-pro'
import { useState } from 'react'
import '@mobiscroll/react/dist/css/mobiscroll.scss'
import { createCalendarDotArray } from '../../../../utils/sharedCalendarFunctions'
setOptions({
  theme: 'ios',
  themeVariant: 'light',
})

export default function DashboardCalendar({
  data,
  handleMonthChange,
  facility_id,
  handleDateChange,
  marks,
  selectedDate,
}) {
  const [markedFacilityData, setMarkedFacilityData] = useState([])

  useEffect(() => {
    setMarkedFacilityData(createCalendarDotArray(data, facility_id))
  }, [data, facility_id])

  const onMonthChange = (args) => {
    handleMonthChange(args)
  }
  const handleDateSelect = (args) => {
    handleDateChange(args)
  }

  return (
    <Datepicker
      className="dashboard-calendar"
      controls={['calendar']}
      display="inline"
      calendarType={'month'}
      theme="material"
      pages={1}
      renderCalendarHeader={() => (
        <CContainer>
          <div className="custom-buttons">
            <CalendarPrev className="custom-prev" />
            <CalendarNav className="custom-nav" />
            <CalendarNext className="custom-next" />
          </div>
        </CContainer>
      )}
      showWeekNumbers={false}
      touchUi={true}
      showOuterDays={true}
      showRangeLabels={false}
      onPageChange={onMonthChange}
      onCellClick={handleDateSelect}
      responsive={{
        custom: {
          display: 'center',
        },
      }}
      markedDisplay="bottom"
      marked={markedFacilityData}
      labels={marks}
      value={selectedDate}
    />
  )
}
